import { useSafeRedirect } from './useSafeRedirect';

export default function RedirectToLogin() {
  useSafeRedirect('/login', true);
  return null;
}
